module.exports = __webpack_public_path__ + "static/media/land-drawer-img--ice.8b5f370e.png";